import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import DinhBienService from "services/DinhBienService";

// ---- Loại cơ sở ----
export const getAllLoai = createAsyncThunk(
  "dinhBien/getAllLoai",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DinhBienService.getAllLoai();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertLoai = createAsyncThunk(
  "dinhBien/upsertLoai",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const res = await DinhBienService.upsertLoai(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteLoai = createAsyncThunk(
  "dinhBien/deleteLoai",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const res = await DinhBienService.deleteLoai(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// ---- Quy mô ----
export const getAllQuyMo = createAsyncThunk(
  "dinhBien/getAllQuyMo",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DinhBienService.getAllQuyMo();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertQuyMo = createAsyncThunk(
  "dinhBien/upsertQuyMo",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const res = await DinhBienService.upsertQuyMo(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteQuyMo = createAsyncThunk(
  "dinhBien/deleteQuyMo",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const res = await DinhBienService.deleteQuyMo(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// ---- Khoa phòng ----
export const getAllKhoaPhong = createAsyncThunk(
  "dinhBien/getAllKhoaPhong",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DinhBienService.getAllKhoaPhong();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertKhoaPhong = createAsyncThunk(
  "dinhBien/upsertKhoaPhong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const res = await DinhBienService.upsertKhoaPhong(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteKhoaPhong = createAsyncThunk(
  "dinhBien/deleteKhoaPhong",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const res = await DinhBienService.deleteKhoaPhong(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// ---- Định biên ----
export const getDinhBienBenhVien = createAsyncThunk(
  "dinhBien/getDinhBienBenhVien",
  async (quyMoId, { rejectWithValue }) => {
    try {
      const res = await DinhBienService.getDinhBienBenhVien(quyMoId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getDinhBienPhongKham = createAsyncThunk(
  "dinhBien/getDinhBienPhongKham",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DinhBienService.getDinhBienPhongKham();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertDinhBienRow = createAsyncThunk(
  "dinhBien/upsertDinhBienRow",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const res = await DinhBienService.upsertDinhBienRow(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  loaiList: [],
  quyMoList: [],
  khoaPhongList: [],
  dinhBienBenhVienData: [],
  dinhBienPhongKhamData: [],
};

const dinhBienSlice = createSlice({
  name: "dinhBien",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const loadingCases = [
      getAllLoai, upsertLoai, deleteLoai,
      getAllQuyMo, upsertQuyMo, deleteQuyMo,
      getAllKhoaPhong, upsertKhoaPhong, deleteKhoaPhong,
      getDinhBienBenhVien, getDinhBienPhongKham, upsertDinhBienRow,
    ];

    loadingCases.forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state) => { state.loading = true; })
        .addCase(thunk.rejected, (state) => { state.loading = false; });
    });

    builder
      .addCase(getAllLoai.fulfilled, (state, action) => {
        state.loading = false;
        state.loaiList = action.payload ?? [];
      })
      .addCase(upsertLoai.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteLoai.fulfilled, (state) => { state.loading = false; })
      .addCase(getAllQuyMo.fulfilled, (state, action) => {
        state.loading = false;
        state.quyMoList = action.payload ?? [];
      })
      .addCase(upsertQuyMo.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteQuyMo.fulfilled, (state) => { state.loading = false; })
      .addCase(getAllKhoaPhong.fulfilled, (state, action) => {
        state.loading = false;
        state.khoaPhongList = action.payload ?? [];
      })
      .addCase(upsertKhoaPhong.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteKhoaPhong.fulfilled, (state) => { state.loading = false; })
      .addCase(getDinhBienBenhVien.fulfilled, (state, action) => {
        state.loading = false;
        state.dinhBienBenhVienData = action.payload ?? [];
      })
      .addCase(getDinhBienPhongKham.fulfilled, (state, action) => {
        state.loading = false;
        state.dinhBienPhongKhamData = action.payload ?? [];
      })
      .addCase(upsertDinhBienRow.fulfilled, (state) => { state.loading = false; });
  },
});

export default dinhBienSlice.reducer;
